import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import './assets/css/tailwind.css';
import keycloakStore from './security/keycloak';
import { makeServer } from './mirage';
import HTTP from './axios-auth';

// Start Mirage server in development mode
if (process.env.NODE_ENV === 'development') {
  // makeServer();
}

// Check for gov.br logout redirect flag before initializing Keycloak or App
const urlParams = new URLSearchParams(window.location.search);
if (urlParams.get('govbr_logout') === 'true') {
  const govBrLogoutUrl = urlParams.get('govbr_logout_url');
  if (govBrLogoutUrl) {
    window.location.href = decodeURIComponent(govBrLogoutUrl);
  }
} else {
  // console.log('registerLoginListener')
  keycloakStore
    .registerLoginListener()
    .then(async ({ authenticated }) => {
      // Setup token interceptor to add JWT to all HTTP requests, regardless of auth status
      // keycloakStore.setupTokenInterceptor(HTTP);

      if (authenticated) {
        keycloakStore.setupUserSession();
      }

      // Setup interceptor after session setup to ensure token is available if authenticated
      keycloakStore.setupTokenInterceptor(HTTP);

      createApp(App).use(router).mount('#app');
    })
    .catch((error) => {
      console.error('Error initializing Keycloak:', error);
    });
}
